import { useCallback, useEffect } from 'react';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { useSnackbar } from 'notistack';
import { getRubrics } from '@dyl/apiClients/backendApi';
import createDatabaseManager from '@dyl/utils/createDatabaseManager';
import createSnackbarAction from '@dyl/utils/createSnackbarAction';

const { Provider: RubricsManager, use: useRaw } = createDatabaseManager({
    requestHook: function useRubricsRequest() {
        const { enqueueSnackbar } = useSnackbar();

        return useCallback(async () => {
            while (true) {
                try {
                    return await getRubrics();
                }
                catch {
                    await new Promise(resolve => enqueueSnackbar( 'Failed to load rubrics', {
                        variant: 'error',
                        persist: true,
                        action: createSnackbarAction({
                            iconComponent: RefreshIcon,
                            onClick: resolve,
                        }),
                    }));
                }
            }
        }, []);
    },
    defaultValue: [],
    contextName: 'RubricsManager',
});

export default RubricsManager;

export function useRubrics() {
    const {
        data: rubrics,
        status: rubricsStatus,
        refresh: refreshRubrics,
    } = useRaw();

    useEffect(() => {
        if (rubricsStatus !== 'complete') {
            refreshRubrics();
        }
    }, [rubricsStatus]);

    return {
        rubrics,
        rubricsStatus,
        refreshRubrics,
    };
}